import type { AdminApi, DataSourceMode } from '@/types/admin'
import { MockAdminApi } from './mockAdminApi'
import { RemoteAdminApi } from './remoteAdminApi'

const configuredMode = import.meta.env.VITE_DATA_SOURCE
export const dataSourceMode: DataSourceMode = configuredMode === 'api' ? 'api' : 'mock'

const apiBaseUrl = (import.meta.env.VITE_API_BASE_URL || '/api/v1').replace(/\/$/, '')

export const adminApi: AdminApi = dataSourceMode === 'api'
  ? new RemoteAdminApi(apiBaseUrl)
  : new MockAdminApi()
